export const MOCK = [
    {
        id: 'ワンルームオークション内借入金',
        label: 'ワンルームオークション内借入金',
        value: 0,
        color: 'hsl(97, 70%, 50%)',
    },
    {
        id: '既存借入額',
        label: '既存借入額',
        value: 0,
        color: 'hsl(141, 70%, 50%)',
    },
    {
        id: '融資可能額',
        label: '融資可能額',
        value: 0,
        color: 'hsl(260, 70%, 50%)',
    },
];
